import DetailVM from './detail-vm';

export default {
  init(element) {
    const announcementData = document.getElementById('announcement_json').value
    const ele = document.getElementById('editor-container');

    ko.applyBindingsWithValidation(
      new DetailVM(announcementData, ele),
      ele,
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    );
  }
};
